import { intl } from "LocaleWrapper";
import { Tag, TagSize } from "@cofano/cck";
import { Box, Tooltip, Typography } from "@mui/material";
import { FormattedDate } from "utils/DateUtils";

type CustomerStatusChangerProps = {
	isUpToDate: boolean;
	lastSentOn?: number | null;
}

const CustomerStatusChanger = ({ isUpToDate, lastSentOn }: CustomerStatusChangerProps) => {
	const title = isUpToDate
		? intl.formatMessage({ id: "CUSTOMER_UPDATE_STATUS_UP_TO_DATE" })
		: intl.formatMessage({ id: "CUSTOMER_UPDATE_STATUS_NOT_UP_TO_DATE" });

	const color = isUpToDate ? "#34D399" : "#FBBF24";

	return (
		<Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 1 }}>
			<Tag color={color} text={title} size={TagSize.NORMAL} />
			{lastSentOn != null && (
				<Tooltip title={intl.formatMessage({ id: "CUSTOMER_UPDATE_LAST_SENT_ON" })}>
					<Typography variant="caption" color="text.secondary">
						<FormattedDate date={lastSentOn} withoutYear />
					</Typography>
				</Tooltip>
			)}
		</Box>
	);
};

export default CustomerStatusChanger;
